import * as ElcEcommQueries from './fe-elc-ecomm';
import * as ElcServiceCartQueries from './fe-elc-service-cart';
import * as ElcServiceCheckoutQueries from './fe-elc-service-checkout';
import * as ElcServiceCommunicationsQueries from './fe-elc-service-communications';
import * as ElcServiceOffersQueries from './fe-elc-service-offers';
import * as ElcServiceOrderHistoryQueries from './fe-elc-service-order-history';
import * as ElcServiceOrderQueries from './fe-elc-service-order';
import * as ElcServicePasswordStrengthQueries from './fe-elc-service-password-strength';
import * as ElcServicePaymentQueries from './fe-elc-service-payment';
import * as ElcServiceProdcatQueries from './fe-elc-service-prodcat';
import * as ElcServiceSaveForLaterQueries from './fe-elc-service-save-for-later';
import * as ElcServiceSignInQueries from './fe-elc-service-sign-in';
import * as ElcServiceSignUpQueries from './fe-elc-service-sign-up';
import * as ElcServiceUserProfileQueries from './fe-elc-service-user-profile';
import * as ElcServiceConfigManagerQueries from './fe-elc-service-config-manager';
import * as ElcServiceTranslationsQueries from './fe-elc-service-translations';
import * as ElcServiceStoreQueries from './fe-elc-service-stores';
import * as ElcServiceApptBookingQueries from './fe-elc-service-appt-booking';
import * as ElcServiceLegalQueries from './fe-elc-service-legal';
import * as ElcServiceContentQueries from './fe-elc-service-content';

const serviceQueries = {
    ...ElcEcommQueries,
    ...ElcServiceCartQueries,
    ...ElcServiceCheckoutQueries,
    ...ElcServiceCommunicationsQueries,
    ...ElcServiceOffersQueries,
    ...ElcServiceOrderHistoryQueries,
    ...ElcServiceOrderQueries,
    ...ElcServicePasswordStrengthQueries,
    ...ElcServicePaymentQueries,
    ...ElcServiceProdcatQueries,
    ...ElcServiceSaveForLaterQueries,
    ...ElcServiceSignInQueries,
    ...ElcServiceSignUpQueries,
    ...ElcServiceUserProfileQueries,
    ...ElcServiceConfigManagerQueries,
    ...ElcServiceTranslationsQueries,
    ...ElcServiceStoreQueries,
    ...ElcServiceApptBookingQueries,
    ...ElcServiceLegalQueries,
    ...ElcServiceContentQueries
};

type ServiceQueries = ElcServiceCartQueries.ServiceCartQueries &
    ElcEcommQueries.ServiceElcEcommQueries &
    ElcServiceCheckoutQueries.ServiceCheckoutQueries &
    ElcServiceCommunicationsQueries.ServiceCommunicationsQueries &
    ElcServiceOffersQueries.ServiceOffersQueries &
    ElcServiceOrderHistoryQueries.ServiceOrderHistoryQueries &
    ElcServiceOrderQueries.ServiceOrderQueries &
    ElcServicePasswordStrengthQueries.ServicePasswordStrengthQueries &
    ElcServicePaymentQueries.ServicePaymentQueries &
    ElcServiceProdcatQueries.ServiceProdcatQueries &
    ElcServiceSaveForLaterQueries.ServiceSaveForLaterQueries &
    ElcServiceSignInQueries.ServiceSignInQueries &
    ElcServiceSignUpQueries.ServiceSignUpQueries &
    ElcServiceTranslationsQueries.ServiceTranslationsQueries &
    ElcServiceConfigManagerQueries.ServiceConfigManagerQueries &
    ElcServiceUserProfileQueries.ServiceUserProfileQueries &
    ElcServiceStoreQueries.ServiceStoreInventoryQueries &
    ElcServiceApptBookingQueries.ServiceApptBookingQueries &
    ElcServiceLegalQueries.ServiceLegalQueries &
    ElcServiceContentQueries.ServiceContentTemplatesQueries;
type ServiceQueriesResponseType = ElcServiceCartQueries.ServiceCartQueriesResponseType &
    ElcEcommQueries.ServiceElcEcommQueriesResponseType &
    ElcServiceCheckoutQueries.ServiceCheckoutQueriesResponseType &
    ElcServiceCommunicationsQueries.ServiceCommunicationsQueriesResponseType &
    ElcServiceOffersQueries.ServiceOffersQueriesResponseType &
    ElcServiceOrderHistoryQueries.ServiceOrderHistoryQueriesResponseType &
    ElcServiceOrderQueries.ServiceOrderQueriesResponseType &
    ElcServicePasswordStrengthQueries.ServicePasswordStrengthQueriesResponseType &
    ElcServicePaymentQueries.ServicePaymentQueriesResponseType &
    ElcServiceProdcatQueries.ServiceProdcatQueriesResponseType &
    ElcServiceSaveForLaterQueries.ServiceSaveForLaterQueriesResponseType &
    ElcServiceSignInQueries.ServiceSignInQueriesResponseType &
    ElcServiceSignUpQueries.ServiceSignUpQueriesResponseType &
    ElcServiceTranslationsQueries.ServiceTranslationsQueriesResponseType &
    ElcServiceConfigManagerQueries.ServiceConfigManagerQueriesResponseType &
    ElcServiceUserProfileQueries.ServiceUserProfileQueriesResponseType &
    ElcServiceStoreQueries.ServiceStoreInventoryQueriesResponseType &
    ElcServiceApptBookingQueries.ServiceApptBookingQueriesResponseType &
    ElcServiceLegalQueries.ServiceLegalQueriesResponseType &
    ElcServiceContentQueries.ServiceContentTemplatesQueriesResponseType;
export { serviceQueries, ServiceQueries, ServiceQueriesResponseType };
